import { useBreakpointValue } from '@gemini/core';
export const useMobile = () => {
    const isMobile = useBreakpointValue({
        base: true,
        xl: false,
    });
    return { isMobile };
};
